import type { CachedAuthIdentity } from "./authIdentityStorage";

/** Whole elapsed hours at capture time, not a cached age or calendar-day count. */
export function accountAnalyticsEventProperties(
    identity: CachedAuthIdentity | null,
    eventTime: Date | string | number = Date.now(),
): Record<string, string | number> {
    if (!identity?.accountCreatedAt) return {};
    const createdAt = Date.parse(identity.accountCreatedAt);
    const capturedAt =
        eventTime instanceof Date
            ? eventTime.getTime()
            : typeof eventTime === "string"
              ? Date.parse(eventTime)
              : eventTime;
    if (!Number.isFinite(createdAt) || !Number.isFinite(capturedAt)) return {};
    return {
        account_created_at: identity.accountCreatedAt,
        // Device clock skew may put an otherwise valid event before signup.
        account_age_hours: Math.max(
            0,
            Math.floor((capturedAt - createdAt) / 3_600_000),
        ),
    };
}
